import {
	STATE_TITLE_TEMPLATE,
	STATE_DESCRIPTION_TEMPLATE
} from "pages/StateLandingPage/utils/stateLandingConstants";

const toTitleCase = (slug) =>
	slug
		.split("-")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");

export const selectStateDetails = (state) => {
	const currentState = state?.stateData?.currentState || {};
	const baseUrl = state?.app?.baseUrl || "https://www.storage.com";
	const stateUrl = currentState.stateUrl || "";
	const fullState = currentState?.location?.fullState || "";
	// const meta = currentState?.meta || {};

	const stateSlug = stateUrl.replace(/^\/?(self-storage\/)?/, "").replace(/\/$/, "");
	const stateName = fullState || toTitleCase(stateSlug);

	const defaultTitle = STATE_TITLE_TEMPLATE(stateName);
	const defaultDescription = STATE_DESCRIPTION_TEMPLATE(stateName);

	return {
		...currentState,
		stateSlug,
		stateName,
		baseUrl,
		location: {
			fullState: fullState || "",
			stateAbbr: currentState?.location?.stateAbbr || ""
		},
		meta: {
			// TODO: will pick these once the PITA changes are done.
			// title: meta.title || defaultTitle,
			// description: meta.description || defaultDescription,
			title: defaultTitle,
			description: defaultDescription,
			canonical: `${baseUrl}/self-storage/${stateSlug}/`
		}
	};
};
